import type { ProcessingLogs } from '../api';

/**
 * True when a failed statement carries a credit-settlement step. Those
 * failures have their own legacy recovery path (POST /files/{id}/retry, shown
 * inside ProcessingLogs); every other failure recovers through the rerun flow.
 * Both surfaces consult this one predicate so a user never sees two
 * competing recovery actions.
 */
export const hasCreditSettlementFailure = (
	logsData?: Pick<ProcessingLogs, 'current_status' | 'logs'> | null,
): boolean => {
	if (!logsData || logsData.current_status !== 'failed') return false;
	return logsData.logs.some((log) =>
		log.step_name.toLowerCase().includes('credit settlement'),
	);
};
